<template>
    <div class="adm-link-group"><slot></slot></div>
</template>
<style lang="scss" scoped>
    .adm-link-group{
        > *{
            padding: 0 .7em;
            position: relative;
            display: inline-block;
            line-height: 1;
            &:after{
                content: "";
                display: inline-block;
                height: 1em;
                width: 1px;
                background-color: #ddd;
                position: absolute;
                top: 0;
                right: 0;
            }
            &[disabled],&.ui-disabled{
                cursor: text;
                color: #9ea7b4;
                pointer-events: none;
            }
            &:last-child:after{
                display: none;
            }
        }
    }
</style>
<script>
export default {

}
</script>
